import * as userActions from '../../reducers/user';

const setUserErrorToNull = () => async (dispatch) => {
  dispatch(userActions.updateUserStart());
};

export default setUserErrorToNull;
